const uriDownload = `${process.env.ADMIN_REST_API}/UserReport/Download_V2`;
const uriCount = `${process.env.ADMIN_REST_API}/UserReport/Download_Count_V2`;
const EXCEL_EXTENSION = '.xlsx';

export function getDownloadUsersCount(data) {
  const payload = {
    CityIds: data.cities,
    CountryIds: [data.countries],
    LobIds: data.lobs,
    RoleIds: data.roles,
    IncludedHeaders: {
      City: data.cityHeader,
      Client: data.clientHeader,
      Country: data.countryHeader,
      Lob: data.lobHeader,
      Role: data.roleHeader,
      Status: data.statusHeader,
      TpId: data.tpIdHeader,
      User: data.userHeader,
      UserName: data.userNameHeader,
    },
  };
  return fetch(uriCount, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => {
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json();
  });
}

export function getUserReports(data) {
  const payload = {
    CityIds: data.cities,
    CountryIds: [data.countries],
    LobIds: data.lobs,
    RoleIds: data.roles,
    IncludedHeaders: {
      City: data.cityHeader,
      Client: data.clientHeader,
      Country: data.countryHeader,
      Lob: data.lobHeader,
      Role: data.roleHeader,
      Status: data.statusHeader,
      TpId: data.tpIdHeader,
      User: data.userHeader,
      UserName: data.userNameHeader,
    },
  };
  return fetch(uriDownload, {
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
      "response-type": "blob",
    },
  })
    .then((res) => {
      return res.blob();
    })
    .then((data) => {
      const url = window.URL.createObjectURL(data);
      const a = document.createElement("a");
      a.href = url;
      a.download = "downloaded-users" + EXCEL_EXTENSION;
      a.click();
      window.URL.revokeObjectURL(url);
    });
}